import BaseAPIService from '@/services/baseAPIService'

export default class OptimiserAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }

  // Config - Optimiser Stock Configs
  getOptimiserStockConfigList()         { return this.httpClient.get(`/optimiser/stockconfigs`) }
  updateOptimiserStockConfigList(data)  { return this.httpClient.put(`/optimiser/stockconfigs`, data) }

  // Optimiser Sheet
  getOptimiserSheet(id)                                { return this.httpClient.get(`/optimiser/sheets/${id}`) }

  getConfigSettings()               { return this.httpClient.get(`/optimiser/settings`) }
  updateConfigSettings(data)        { return this.httpClient.put(`/optimiser/settings`, data) }
}
